import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import { useCart } from '../context/CartContext';
import { formatCurrencyShort } from '../utils/currency';
import { BRAND } from '../data/brand';

const products = [
  { id:'p1', title:'Luxury Towel Set',   price:3900,  oldPrice:5500, badge:'Sale', type:'product' },
  { id:'p2', title:'Scented Candle',     price:1600,  oldPrice:null, badge:'New',  type:'product' },
  { id:'p3', title:'Premium Bathrobe',   price:8900,  oldPrice:12000,badge:'Sale', type:'product' },
  { id:'p4', title:'Pillow Set',         price:4500,  oldPrice:null, badge:null,   type:'product' },
  { id:'p5', title:'Room Diffuser',      price:2800,  oldPrice:null, badge:'New',  type:'product' },
  { id:'p6', title:'Hotel Slippers',     price:1900,  oldPrice:2800, badge:'Sale', type:'product' },
  { id:'p7', title:'Toiletry Gift Kit',  price:3500,  oldPrice:null, badge:null,   type:'product' },
  { id:'p8', title:'Mineral Water Pack', price:1200,  oldPrice:null, badge:null,   type:'product' },
];

const badgeColor = { Sale:'#c0392b', New:'#2d7a4f' };

export default function ShopProducts() {
  const { addToCart, cartItems, cartCount } = useCart();
  const [flashed, setFlashed] = useState({});

  const handleAdd = (p) => {
    addToCart({ id:p.id, title:p.title, price:p.price, img:BRAND.logo, type:'product' });
    setFlashed(f => ({ ...f, [p.id]: true }));
    setTimeout(() => setFlashed(f => ({ ...f, [p.id]: false })), 1800);
  };

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header />
      <PageTitle title="Hotel Shop" breadcrumbs={[{ label:'Shop' }]} />

      <section style={{ padding:'60px 0' }}>
        <div className="auto-container">

          {cartCount > 0 && (
            <div className="cart-notice mb-4">
              <i className="fas fa-cart-shopping"></i>
              <span><strong>{cartCount}</strong> item{cartCount>1?'s':''} in your cart</span>
              <Link to="/cart" className="cart-notice-link">View Cart →</Link>
            </div>
          )}

          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:20 }}>
            {products.map(p => {
              const inCart = cartItems.some(i => i.id === p.id);
              const flash  = flashed[p.id];
              return (
                <div key={p.id}
                  style={{ background:'#fff', border:'1px solid #e8e3dc', borderRadius:6, overflow:'hidden', transition:'box-shadow 0.2s, transform 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow='0 8px 28px rgba(0,0,0,0.09)'; e.currentTarget.style.transform='translateY(-3px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow=''; e.currentTarget.style.transform=''; }}>
                  <div style={{ background:'#f9f8f6', height:180, display:'flex', alignItems:'center', justifyContent:'center', position:'relative' }}>
                    <img src={BRAND.logo} alt={p.title} style={{ height:80, objectFit:'contain', opacity:0.25 }} />
                    {p.badge && (
                      <span style={{ position:'absolute', top:10, left:10, background:badgeColor[p.badge]||'#b08d57', color:'#fff', fontSize:10, fontWeight:700, letterSpacing:1, padding:'3px 9px', borderRadius:2 }}>{p.badge}</span>
                    )}
                    {inCart && (
                      <span style={{ position:'absolute', top:10, right:10, width:26, height:26, background:'#2d7a4f', color:'#fff', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12 }}>
                        <i className="fas fa-check"></i>
                      </span>
                    )}
                  </div>
                  <div style={{ padding:'16px' }}>
                    <h6 style={{ fontSize:14, color:'#111', marginBottom:6 }}>{p.title}</h6>
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:12 }}>
                      <span style={{ fontFamily:'var(--gw-font-h,serif)', fontSize:18, fontWeight:700, color:'#b08d57' }}>
                        {formatCurrencyShort(p.price)}
                      </span>
                      {p.oldPrice && (
                        <span style={{ fontSize:12, color:'#bbb', textDecoration:'line-through' }}>
                          {formatCurrencyShort(p.oldPrice)}
                        </span>
                      )}
                    </div>
                    <button
                      onClick={() => handleAdd(p)}
                      style={{ width:'100%', padding:'9px', background:flash?'#27ae60':inCart?'#2d7a4f':'#b08d57', color:'#fff', border:'none', borderRadius:3, fontSize:12, fontWeight:700, cursor:'pointer', transition:'background 0.2s' }}>
                      {flash ? '✓ Added' : inCart ? '✓ In Cart' : 'Add to Cart'}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </section>

      <Footer /><ScrollToTop />
    </div>
  );
}
